export default __webpack_public_path__ + "static/575-b8a858d93a3efce4c06de3a7d4a580cf.gif";